import TagManagerBase from "../../GoogleTagManager/TagManagerBase";

export enum eventCategoryForGTM {
    summaryTab = "summary tab",
    investmentsTab = "investments tab",
    performanceTab = "performance tab",
    insightsTab = "insights tab",
    transactionsTab = "transactions tab",
    activityTab = "activity tab",
    documentTab = "document tab",
    aumTab = "aum tab",
    wrapperSummaryTab = "wrapper summary tab",
    adviserChargesTab = "adviser charges tab",
    clientSummaryTab = "client summary tab",
    esgAnalyserTab = "esg hub tab",
    productOverviewCrystallisationTab = "product overview crystallisation tab",
    totalIncomePayeeTab = "total income Payee tab"
}

export type AdviserSiteTagManagerEvent = {
    event: string;
    environment?: {
        appType: string;
        setting: string;
        timestamps: string;
    };
    user?: {
        loginId: string;
        internal: string;
    };
    page?: {
        pageUrl: string;
        pageTitle: string;
    };
    eventParameters?: {
        eventCategory: eventCategoryForGTM;
        eventAction: string;
        eventLabel: string;
    };
    filter?: {
        type?: string;
        tier?: string;
        date?: string;
        actvityType?: string;
        product?: string;
        activityStatus?: string;
    };
    document?: {
        title: string;
        url: string;
        id?: string;
    };
    tableEditor?: {
        targetAllocation: string;
        fundCode: string;
        Location: string;
        protectAssets: string;
    };
    clientReport?: {
        dateRange: string;
        reportView: "total portfolio" | "product view";
        format: "pdf" | "word";
        accountDetails: "yes" | "no";
        snapshot: "yes" | "no";
        valuation: "yes" | "no";
        performance: "yes" | "no";
        insights: "yes" | "no";
        transactions: "yes" | "no";
        calculationBasis: "irr" | "simple";
    };
    reportingIntroduction?: {
        include: "yes" | "no";
        cover: "yes" | "no";
        contents: "yes" | "no";
        commentary: "yes" | "no";
        image: "yes" | "no";
    };
    graphs?: {
        valuation: "yes" | "no";
        return: "yes" | "no";
        cumulative: "yes" | "no";
        discrete: "yes" | "no";
    };
    breakdown?: {
        include: "yes" | "no";
        valuation: "yes" | "no";
        performance: "yes" | "no";
    };
    benchmark?: {
        include: "yes" | "no";
        noOfBenchmarks: string;
    };
};

class AdviserSiteTagManager extends TagManagerBase<AdviserSiteTagManagerEvent> {
    public constructor() {
        super();
    }
}

export default AdviserSiteTagManager;
